<span class="primary">ShareView</span>
<qr-code [value]="'46f1e21c-be36-4eff-8dd4-e6586ac49a09'" size="200"></qr-code>
<span class="secondary">For Clinicians Only</span>
